/**
 * Rute aplikasi konsumen (URL tanpa kata "portal"/"sandbox").
 * Dipakai deteksi JWT portal di klien API video/sosial dan navigasi pemutar.
 */
export const CONSUMER_ROUTE_NAMES = new Set([
  "ConsumerMasuk",
  "ConsumerDaftar",
  "ConsumerLupaSandi",
  "ConsumerResetSandi",
  "ConsumerAkunAktif",
  "ConsumerPreferensi",
  "ConsumerHarga",
  "ConsumerFeed",
  "ConsumerProfil",
  "ConsumerSearch",
  "ConsumerNotificationsInbox",
  "ConsumerNotificationDetail",
  "ConsumerBatalEmail",
  "ConsumerVideo",
])

/** Beranda & tab Serial/Film/Daftar Saya: katalog publik & portal API (tanpa /admin). */
const CONSUMER_MARKETING_PATHS = new Set(["/", "/series", "/films", "/daftar-saya"])

/** Path yang memakai sesi JWT konsumen (bukan admin). */
const CONSUMER_PATH_PREFIXES = [
  "/masuk",
  "/daftar",
  "/lupa-kata-sandi",
  "/atur-ulang-kata-sandi",
  "/akun-aktif",
  "/preferensi",
  "/harga",
  "/feed",
  "/profil",
  "/cari",
  "/notifikasi",
  "/batal-email",
  "/tonton/",
]

/** True jika pathname adalah area konsumen (SSR-safe). */
export function isConsumerAppPath(pathname: string): boolean {
  if (!pathname || pathname.startsWith("/admin")) return false
  if (CONSUMER_MARKETING_PATHS.has(pathname)) return true
  for (const p of CONSUMER_PATH_PREFIXES) {
    if (p.endsWith("/")) {
      if (pathname.startsWith(p)) return true
    } else if (pathname === p || pathname.startsWith(`${p}/`)) {
      return true
    }
  }
  return false
}

/** Untuk video.ts / social.ts / series.ts - pakai klien portal di permukaan konsumen. */
export function isConsumerJwtSurface(): boolean {
  if (typeof window === "undefined") return false
  return isConsumerAppPath(window.location.pathname)
}
